export default __webpack_public_path__ + "static/media/AlertWarning.e463ba33.svg";